// extracted by mini-css-extract-plugin
module.exports = {"container":"AnimatedView_container__kwbJA","view":"AnimatedView_view__msv_l"};